<template>
	<el-dialog :title="title" :visible.sync="visible" width="60%" @close="onClose">
		<el-table :data="blocks" border size="small" empty-text="无阻断明细">
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="key" label="项目" min-width="140"></el-table-column>
			<el-table-column prop="reason" label="原因" min-width="220"></el-table-column>
		</el-table>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="visible = false">关闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: "ExportBlockDialog",
	props: {
		visible: { type: Boolean, default: false },
		title: { type: String, default: "导出提示" },
		blocks: { type: Array, default: () => [] }
	},
	methods: {
		onClose() {
			this.$emit("update:visible", false);
		}
	}
};
</script>
